import { render, staticRenderFns } from "./TiptapInput.vue?vue&type=template&id=2f64a350&scoped=true&"
import script from "./TiptapInput.vue?vue&type=script&lang=js&"
export * from "./TiptapInput.vue?vue&type=script&lang=js&"
import style0 from "./TiptapInput.vue?vue&type=style&index=0&id=2f64a350&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f64a350",
  null
  
)

export default component.exports